import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { useNavigate } from "react-router-dom";
import Pagination from "../../ResuableCompoment/Pagination";
import SearchBar from "../../ResuableCompoment/SearchBar";
import useApi from "../../CustomHooks/useApi";
import { useSelector } from 'react-redux';
import { getDisplayDate } from "../../ResuableCompoment/GetDisplayDate";

const Dashboard = () => {
  const [loading, setLoading] = useState(true);
  const [formsData, setFormsData] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [rawResponse, setRawResponse] = useState([]);
  const itemsPerPage = 10;
  const navigate = useNavigate();

  const mobilenumber = useSelector((state) => state.auth.employeeDetails.mobile_number);

  const { callApi: checkerdata } = useApi(
    `/staff/onboard/compliance/access?mobileNumber=${mobilenumber}`,
    "GET"
  );

  useEffect(() => {
    fetchFormsData();
  }, []);

  useEffect(() => {
    console.log("setrawdataa", rawResponse);
  }, [rawResponse]);

  const fetchFormsData = async () => {
    try {
      const response = await checkerdata();
      if (response?.length > 0) {
        setRawResponse(response);
        const extractedData = response.map((item) => {
          const hierarchy = item?.hierarchyResponses?.parent || {};
          let d = "-";
          let md = "-";
          let asm = "-";
          let sh = "-";
          let rm = "-";
          

          let currentParent = hierarchy;
          while (currentParent) {
            switch (currentParent?.role) {
              case "DISTRIBUTOR":
                d = currentParent?.name || "-";
                break;
              case "MASTER_DISTRIBUTOR":
                md = currentParent?.name || "-";
                break;
              case "ASM":
                asm = currentParent?.name || "-";
                break;
              case "STATE_HEAD":
                sh = currentParent?.name || "-";
                break;
              case "REGIONAL_SALES_MANAGER":
                rm = currentParent?.name || "-";
                break;
            }
            currentParent = currentParent?.parent || null;
          }

          return {
            name: item?.fullName || "-",
            created_at: item.created_at || "-",
            userId: item.userId || "-",
            message: item.message || "-",
            mobileNumber: item?.mobileNumber || "-",
            role: item?.hierarchyResponses?.role || "-",
            d,
            md,
            asm,
            sh,
            rm,
            gstTradeName: item?.meta?.gstTradeName || "-",
          };
        });

        setFormsData(extractedData);
      } else {
        setFormsData([]);
      }
      setLoading(false);
    } catch (err) {
      console.error("Error fetching data:", err);
      setLoading(false);
    }
  };




  const filteredForms = formsData.filter(
    (form) =>
      form.name.toLowerCase().includes(searchQuery.toLowerCase()) ||
      form.role.toLowerCase().includes(searchQuery.toLowerCase()) ||
      form.mobileNumber.includes(searchQuery) ||
      form.userId.includes(searchQuery)
  );

  return (
    <div className="min-h-screen bg-[#EEF1F5] p-6">
      {/* Search */}
      <div className="mb-6">
        <SearchBar
          placeholder="Search by Name, Role, ID, or Mobile"
          value={searchQuery}
          onChange={(e) => setSearchQuery(e.target.value)}
        />
      </div>

      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        className="bg-white border border-gray-200 rounded-xl p-6"
      >
        {/* Heading (same style as OnboardingComplete) */}
        <div className="mb-5 text-center">
          <h2 className="text-lg font-semibold text-[#0A2A4F]">
            Newly Onboard
          </h2>
        </div>

        {/* Table */}
        {loading ? (
          <p className="text-center text-gray-500">Loading...</p>
        ) : filteredForms.length === 0 ? (
          <p className="text-center text-red-500">No data found</p>
        ) : (
          <Pagination
            items={filteredForms}
            itemsPerPage={itemsPerPage}
            currentPage={currentPage}
            onPageChange={setCurrentPage}
            renderItems={(currentItems) => (
              <div className="overflow-x-auto">
                <table className="min-w-full border border-gray-200 rounded-lg overflow-hidden table-fixed">
                  <thead className="bg-[#0A2A4F] text-white">
                    <tr>
                      <th className="px-4 py-3 text-left text-sm font-medium w-[180px]">
                        Name
                      </th>

                      <th className="px-4 py-3 text-left text-sm font-medium w-[180px]">
                        GST Trade Name
                      </th>

                      <th className="px-4 py-3 text-left text-sm font-medium w-[140px]">
                        Mobile
                      </th>
                      <th className="px-4 py-3 text-left text-sm font-medium w-[120px]">
                        Role
                      </th>
                      <th className="px-4 py-3 text-left text-sm font-medium w-[80px]">
                        D
                      </th>
                      <th className="px-4 py-3 text-left text-sm font-medium w-[80px]">
                        MD
                      </th>
                      <th className="px-4 py-3 text-left text-sm font-medium w-[80px]">
                        ASM
                      </th>
                      <th className="px-4 py-3 text-left text-sm font-medium w-[80px]">
                        SH
                      </th>
                      <th className="px-4 py-3 text-left text-sm font-medium w-[80px]">
                        RSM
                      </th>
                      <th className="px-4 py-3 text-left text-sm font-medium w-[140px]">
                        User ID
                      </th>
                      <th className="px-4 py-3 text-left text-sm font-medium w-[160px]">
                        Date / Time
                      </th>
                      <th className="px-4 py-3 text-center text-sm font-medium w-[100px]">
                        Created By
                      </th>
                      <th className="px-4 py-3 text-center text-sm font-medium w-[100px]">
                        Action
                      </th>

                    </tr>
                  </thead>

                  <tbody>
                    {currentItems.map((form, index) => (
                      <tr
                        key={index}
                        className="border-b last:border-none hover:bg-gray-50 transition"
                      >
                        <td className="px-4 py-3 truncate">{form.name}</td>

                        <td className="px-4 py-3 truncate" title={form.gstTradeName}>
                          {form.gstTradeName}
                        </td>

                        <td className="px-4 py-3 whitespace-nowrap">
                          {form.mobileNumber}
                        </td>

                        <td className="px-4 py-3">
                          <span className="px-2 py-1 rounded-full bg-slate-100 text-slate-700 text-xs">
                            {form.role}
                          </span>
                        </td>

                        <td className="px-4 py-3 text-center">{form.d}</td>
                        <td className="px-4 py-3 text-center">{form.md}</td>
                        <td className="px-4 py-3 text-center">{form.asm}</td>
                        <td className="px-4 py-3 text-center">{form.sh}</td>
                        <td className="px-4 py-3 text-center">{form.rm}</td>

                        <td className="px-4 py-3 whitespace-nowrap font-mono text-sm">
                          {form.userId}
                        </td>

                        <td className="px-4 py-3 whitespace-nowrap text-sm">
                          {getDisplayDate(form.created_at)}
                        </td>

                        <td className="px-4 py-3 whitespace-nowrap text-sm">
                          {form.message}
                        </td>

                        <td className="px-4 py-3 text-center">
                          <button
                            onClick={() =>
                              navigate("/document-detail", {
                                state: {
                                  form: rawResponse.find(
                                    (item) => item.mobileNumber === form.mobileNumber
                                  ),
                                },
                              })
                            }
                            className="px-4 py-1.5 rounded-lg text-sm bg-[#0A2A4F] text-white hover:bg-[#08305e]"
                          >
                            Open
                          </button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>

              </div>
            )}
          />
        )}
      </motion.div>
    </div>
  );

};

export default Dashboard;
